import React, { useEffect, useState } from 'react';
import "./CheckoutContainer.css";
import { useSelector } from 'react-redux';
import AddressBox from '../AddressBox/AddressBox';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Col, Container, Modal, Row, Spinner, Form } from 'react-bootstrap';

function CheckoutContainer({ sendDataToParent }) {
  const userinfo = useSelector((state) => state);
  const [address, setAddress] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [phone, setPhone] = useState(userinfo.auth.userArray?.phone || '');
  const [notes, setNotes] = useState('');
  const [alert, setAlert] = useState('');

  const [paymentMethod, setPaymentMethod] = useState('cash'); // default cash
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [cities, setCities] = useState('')
  const [block, setBlock] = useState("");

  const [region, setRegion] = useState('')
  const [street, setStreet] = useState('')
  const [house_number, setHouse_number] = useState('')
  const [addressnotes, setAddressNotes] = useState('')
  const [msg, setMsg] = useState('');
  const [severity, setSeverity] = useState('');
  const [show, setShow] = useState(false);

  const [name, setName] = useState(userinfo.auth.userArray?.name || '')
  const [city, setCity] = useState('')
  const [loading, setLoading] = useState(false)

  const [modalShow, setModalShow] = useState(false);



  const sendData = async (e) => {
    e.preventDefault();
    setLoading(true)
    const data = {
      "title": name,

      "city_id": city,

      latitude:
        30.123456,

      longitude:
        31.123456,

      region,

      street,
      block,
      house_number,
      notes: addressnotes,
      phone,
      default: 1

    };

    await axios
      .post(`https://nanosoft.technology/outlaw/api/client/addresses`, data,


        {
          headers: {
            Authorization: `Bearer ${userinfo?.auth?.access_token}`
          }
        })
      .then(async (res) => {
        setLoading(false)

        setShow(true)
        setMsg(currentLocal.home.addsuccessMessage)
        setSeverity("success")
        window.location.reload();

        setTimeout(() => {
          setShow(false);
          setName("")
          setCity("")
          setRegion("")
          setStreet("")
          setBlock("")
          setHouse_number("")
          setAddressNotes("")
          setPhone("")

          setMsg("")


        }, 2000);
      })

      .catch((error) => {
        setLoading(false)

        setAlert(error.response.data.error)
        // Toast.show("Email or password is not correct!", {
        //   type: "danger",
        // });
      });
  }
  // ✅ Send data to parent every time a relevant field changes
  useEffect(() => {

    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/outlaw/api/countries/1/cities`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })

        .then(async (res) => {
          setCities(res.data.data.data);

          // setShow(true)

          //                     setAddress(res.data)

        })
        .catch((error) => {
          console.log(error.response.data?.message);

          setLoading(false)
          setShow(true)
          setMsg(error.response.data?.message)
          setSeverity("error")
          setTimeout(() => {
            setShow(false)

          }, 1500);


        });

    }
    getAllApis()

    sendDataToParent({
      payment_method: 'cash', // 'cash'
      coupon: "", // you can later add coupon field
      "client_name": name,
      "client_city": city,
      client_region: region,
      client_street: street,
      client_block: block,
      client_house_number: house_number,

      note: notes,

      client_phone: phone,
      client_address_notes: addressnotes,

      client_latitude:
        30.123456,

      client_longitude:
        31.123456,



    });
  }, [phone, notes, name, city, region, street, block, house_number, addressnotes]);

  return (
    <div className="checkout_container">
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='edit_model'
      >
        <Modal.Header closeButton className='py-1 border-bottom-0'>

        </Modal.Header>


        <Modal.Footer className='justify-content-between'>

          {/* <button type="submit" className=" edit_btn " onClick={sendData}>{currentLocal.home.Save}</button> */}
          <button className={loading ? 'disaactive_login_btn d-flex justify-content-center align-items-center' : 'login_btn d-flex justify-content-center align-items-center'} type='submit' disabled={loading && true} onClick={sendData}>
            {loading &&
              <Spinner animation="border" role="status" className='mx-3' size="sm">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            }
            <p className='mb-0'>
              {currentLocal.home.add}
            </p>
          </button>
        </Modal.Footer>
      </Modal>

      <Container>
        <Row>
          <Col md={12}>
            <div className="mb-4">
              <h3>{currentLocal.home.Notes}</h3>
              <textarea
                value={notes}
                className="phone_number"
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </Col>


        </Row>
      </Container>

      <div className="mb-4">
        <div className="d-flex justify-content-between">
          <h3>{currentLocal.home.Address}</h3>
          {/* {!selectedAddress&&
          <div onClick={handleShow}>{currentLocal.home.add}</div>
} */}
        </div>

        {selectedAddress ? (
          <AddressBox item={selectedAddress} />
        ) :
          <form className='mx-3'>

            <Container>
              <Row>




                <Col md={12}>
                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.namePlaceholder} </label>
                    <input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className='w-100'
                    />
                  </div>
                </Col>
                <Col md={12}>


                  <label className='my-1'>{currentLocal.home.city} </label>

                  <Form.Select aria-label="Product In Stock"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}>
                    <option>City</option>
                    {cities && cities.map((item, index) => {

                      return (
                        <option value={item.id} key={index}>{item.name}</option>

                      )
                    })}
                  </Form.Select>
                </Col>
                <Col md={6}>
                  <div className='my-3'>
                    <label className='mb-1'>{currentLocal.home.region}  </label>
                    <input
                      placeholder={currentLocal.home.region}
                      value={region}
                      onChange={(e) => setRegion(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                <Col md={6}>

                  <div className='my-3'>
                    <label className='mb-1'> {currentLocal.home.street}  </label>
                    <input
                      placeholder={currentLocal.home.street}
                      value={street}
                      onChange={(e) => setStreet(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                <Col md={6}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.buildingNumber}  </label>
                    <input
                      placeholder={currentLocal.home.buildingNumber}
                      value={block}
                      onChange={(e) => setBlock(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                <Col md={6}>

                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.house_number}  </label>
                    <input
                      placeholder={currentLocal.home.house_number}
                      value={house_number}
                      onChange={(e) => setHouse_number(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                <Col md={12}>

                  <div className='my-3'>
                    <label className='mb-1'>{currentLocal.home.phone} </label>
                    <input
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                <Col md={12}>
                  <div className='mb-3'>
                    <label className='mb-1'>{currentLocal.home.Detailedaddress}  </label>

                    <input
                      placeholder={currentLocal.home.Detailedaddress}

                      value={addressnotes}
                      onChange={(e) => setAddressNotes(e.target.value)}
                      className='w-100'

                    />
                  </div>
                </Col>
                {/* <button className={loading?'disaactive_login_btn d-flex justify-content-center align-items-center rounded':'login_btn d-flex justify-content-center align-items-center rounded'} type='submit'disabled={loading && true}onClick={sendData}>
                        {loading &&
                                      <Spinner animation="border" role="status" className='mx-3' size="sm">
                                          <span className="visually-hidden">Loading...</span>
                                      </Spinner>
                                  }
                                    <p className='mb-0'>  
                {currentLocal.home.add}
                </p>
              </button> */}
              </Row>
            </Container>








          </form>
        }
      </div>

      {/* <div className="mb-4">
        <h3>
{currentLocal.home.Payment}
        </h3>
        <div className="payment_method">
          <input
            type="radio"
            id="CASH"
            name="method"
            value="cash"
            checked={paymentMethod === "cash"}
            onChange={(e) => setPaymentMethod(e.target.value)}
          />
          <label className="mx-2 w-75" htmlFor="CASH">
            {currentLocal.home.Cash}
          </label>
        </div>

      </div> */}
    </div>
  );
}

export default CheckoutContainer;
